<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import DatePicker from "vue2-datepicker";
import moment from "moment";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    data() {
        return {
            title: "Listado de Pago Laborantes",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            pagos_laborantes:[],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filtro: '',
            desde:'',
            hasta:'',
            us:{},
            tipos:[],
            subtipos:[],
        };
    },
    computed:{
        filteredData() {
            if (!this.filtro) {
                return this.pagos_laborantes; // Si no hay filtro, mostrar todo
            }
            // Filtramos los datos en base al campo 'filtro' 
            return this.pagos_laborantes.filter((item) => {
                return item.name.toLowerCase().includes(this.filtro.toLowerCase());
            });
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredData.slice(start, end)
        },
        totalRows() {
            return this.filteredData.length;
        },
    },
    methods:{
        obtenerRangoFechas() {
            const hoy = new Date();
            const diaHoy = hoy.getDate();
            const mesHoy = hoy.getMonth();
            const anioHoy = hoy.getFullYear();
            
            let fechaInicio, fechaFin;
            
            if (diaHoy <= 25) {
                // Si hoy es menor o igual a 25, el rango es del 26 del mes anterior al 25 de este mes
                const mesAnterior = mesHoy === 0 ? 11 : mesHoy - 1;
                const anioInicio = mesHoy === 0 ? anioHoy - 1 : anioHoy;
                fechaInicio = new Date(anioInicio, mesAnterior, 26);
                fechaFin = new Date(anioHoy, mesHoy, 25);
            } else {
                // Si hoy es mayor a 25, el rango es del 26 de este mes al 25 del mes siguiente
                const mesSiguiente = mesHoy === 11 ? 0 : mesHoy + 1;
                const anioFin = mesHoy === 11 ? anioHoy + 1 : anioHoy;
                fechaInicio = new Date(anioHoy, mesHoy, 26);
                fechaFin = new Date(anioFin, mesSiguiente, 25);
            }
            this.desde = moment(fechaInicio).format('YYYY-MM-DD');
            this.hasta = moment(fechaFin).format('YYYY-MM-DD');
            //return { fechaInicio, fechaFin };
        },
        mostrarmes(){
            axios.get('/api/apagar/'+this.desde+'/'+this.hasta).then(response => {
                if (this.user.rol=='Admin') {
                    this.pagos_laborantes= response.data.pagos_laborantes;
                }else if(this.user.rol=='Supervisor'){
                    this.pagos_laborantes= response.data.pagos_laborantes.filter((us) => us.sede==this.user.sede);
                }else if(this.user.rol=='Coordinador'){
                    this.pagos_laborantes = response.data.pagos_laborantes
                    // 1. Filtra solo laborantes donde el coordinador actual está incluido
                    .filter(laborante => laborante.coordinadores.includes(this.user.id))
                    // 2. Filtra los pagos de cada laborante para que solo se muestren los del coordinador actual
                    .map(laborante => {
                        return {
                            ...laborante,
                            pagos: laborante.pagos.filter(pago => pago.user_id == this.user.id)
                        };
                    });
                }
            });
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        ver_detalle(user){
            this.us=user;
            this.us.pagos.forEach(element => {
                element.tipo_nombre = this.tipos.find(t => t.id == element.tipo);
                element.subtipo_nombre = this.subtipos.find(t => t.codigo == element.subtipo);
            });
            this.$refs['modal-detalle'].show()
        },
        formatFecha(fechahora){
            var orden = moment(fechahora).format('DD-MM-YYYY');
            return orden
        },
    },
    mounted(){
        this.obtenerRangoFechas();
        this.mostrarmes();
        axios.get('/api/get_tipos').then(res=>{
            this.tipos=res.data.tipos
            this.subtipos=res.data.subtipos
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12">
                <div class="card mt-3">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Desde :" label-for="text" >
                                    <date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-5">
                                <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Hasta :" label-for="text" >
                                    <date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" ></date-picker>
                                </b-form-group>
                            </div>
                            <div class="col-md-2">
                                <b-button variant="primary" block class="mb-4" @click="mostrarmes">Ver</b-button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;recibos
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filtro"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Nº</th>
                                        <th >Nombre</th>
                                        <th >Rut</th>
                                        <th >Total a Pagar</th>
                                        <th >Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in filteredData" :key="index" :class="item.total_liquido>=250000 ?'bg-danger text-white':''">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ item.nombre_laborante }}</td>
                                        <td>{{ item.rut }}</td>
                                        <td>{{ format_Valor_variable(item.total_liquido) }}</td>
                                        <td>
                                            <b-button variant="primary" size="sm" @click="ver_detalle(item)">Ver</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <b-modal ref="modal-detalle" size="xl" hide-footer :title="'Pagos '+us.nombre_laborante">
                            <div class="table-responsive mb-0 mt-3">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th >Nº</th>
                                        <th >Evento(s)</th>
                                        <th >Fecha</th>
                                        <th >Tipo</th>
                                        <th >Subtipo</th>
                                        <th >Tipo apoyo</th>
                                        <th >Horas</th>
                                        <th >Cant. encuestas</th>
                                        <th >Coordinador</th>
                                        <th >Monto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item2, index2) in us.pagos" :key="index2">
                                        <td>{{ index2 + 1 }}</td>
                                        <td>{{ item2.cod_evento }}</td>
                                        <td>{{ formatFecha(item2.fecha) }}</td>
                                        <td>{{ item2.tipo_nombre.nombre }}</td>
                                        <td>{{ item2.subtipo_nombre.nombre }}</td>
                                        <td>{{ item2.tipo_laborante }}</td>
                                        <td>{{ item2.total_horas }}</td>
                                        <td>{{ item2.cantidad_encuestas }}</td>
                                        <td>{{ item2.user_id }}</td>
                                        <td>{{ format_Valor_variable(item2.valor_liquido) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </b-modal>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>